<template>
  <div id="Services" class="wrap">
    <div class="maxContainer" v-if="servicesList.length">
      <div class="parent">
        <ServiceProduct
          v-for="(product, index) in servicesList"
          :key="index"
          :data="product"
        />
        <a
          href="https://courses.healthcareercerts.org/?utm_source=mypabox&utm_medium=banner&utm_campaign=mypabox100&utm_id=Partnership"
          style="textDecoration: none;"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="ServiceProduct__textCover ServiceProduct">
            <div class="ServiceProduct__image">
              <img src="@/assets/HealthCertServicesImg.jpeg" alt="" />
            </div>
            <h1 class="ServiceProduct__title">
              Certifications to gain Patient Care Experience (PCE)
            </h1>
            <p class="ServiceProduct__text">
              Paid Clinical Experience is a crucial component of a strong PA
              school application. Becoming a nationally certified clinical
              medical assistant gives you the chance to work in a clinical
              setting and gain hands-on experience. HealthCareer Certs offers a
              flexible and convenient certification program. By dedicating just
              2 hours per day, the program can be completed in 8 weeks. With a
              100% passing rate, you'll be fully prepared to obtain the required
              2,000+ PCE hours. Use the code <b>"myPAbox100"</b> and get $200
              off!
            </p>
            <span
              class="ServiceProduct__button myPaBoxButton v-btn v-btn--depressed theme--light v-size--default info"
              ><span
                href="https://courses.healthcareercerts.org/?utm_source=mypabox&utm_medium=banner&utm_campaign=mypabox100&utm_id=Partnership"
                class="v-btn__content"
                >Discover More</span
              ></span
            >
          </div>
        </a>
      </div>
      <!--
        <p>Test</p>
        <img src="@/assets/PCEHours.png" alt="" />
      -->
    </div>
  </div>
</template>

<script>
import ServiceProduct from "@/components/Services/ServiceProduct";
import { mapActions, mapState } from "vuex";
export default {
  name: "Services",
  data() {
    return {};
  },
  components: {
    ServiceProduct
  },
  computed: {
    ...mapState("services", ["servicesList"])
  }
};
</script>

<style scoped>
.maxContainer {
  margin: 50px 0;
}

.parent {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}

@media (min-width: 769px) {
  .wrap {
    padding-top: 40px;
  }

  .parent {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }

  .maxContainer {
    margin: 0 auto 57px;
  }
}

@media (min-width: 900px) {
  .parent {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }
  .maxContainer {
    max-width: 1280px;
    margin: 50px 0;
  }
}

.ServiceProduct {
  background-color: #bacdd9;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
/* .ServiceProduct:nth-child(even) {
    flex-direction: row-reverse;
    margin: 30px auto;
    text-align: right;
} */
.ServiceProduct__textCover {
  position: relative;
  z-index: 2;
  height: 100%;

  display: flex;
  flex-direction: column;
}
.ServiceProduct__image {
  position: relative;
  overflow: hidden;
}
.ServiceProduct__image::before {
  content: "";
  display: inline-block;
  padding-bottom: 65%;
}
.ServiceProduct__image img {
  display: block;
  width: 100%;
  position: absolute;
  top: 0%;
  left: 0%;
  object-fit: cover;
  height: 100%;
}
.ServiceProduct__image::after {
  z-index: 1;
  content: "";
  position: absolute;
  bottom: 10px;
  right: -10px;
  width: 1000px;
  height: 50px;
  display: block;
  background-color: #bacdd9;
  transform: rotate(7deg);
}

.ServiceProduct__title {
  font-size: 20px;
  line-height: 1.3;
  color: #191340;
  padding-bottom: 41px;
  position: relative;
  padding: 8px 32px 16px;
}
/* .ServiceProduct__title::before {
    content: '';
    background-color: #191340;
    height: 2px;
    width: 30px;
    display: block;
    position: absolute;
    bottom: 16px;
    left: 32px;
} */

.ServiceProduct__text {
  color: #191340;
  padding: 0 32px;
}

.myPaBoxButton {
  background-color: #191340 !important;
  border-color: #191340 !important;
}
.ServiceProduct__button {
  margin-top: auto;
  margin: auto 32px 32px;
}

@media (max-width: 900px) {
  .ServiceProduct {
    max-width: 100%;
  }

  .ServiceProduct__image {
    display: none;
  }

  .ServiceProduct__textCover {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/Services.vue